<template>
    <div
      class="col-6 col-lg-4"
      v-for="(conf, i) in selectedConfig.upgrade"
      :key="i"
    >
      <div class="crafting-tool_group">
        <span class="text-default">To upgrade level by {{ conf.key + " you need " + conf.value }} WWS</span>
      </div>
    </div>
</template>

<script>
export default {
  name: "UpgradeConfig",
  props: ["selectedConfig"],
};
</script>
<style scoped>
.form-group input{
  padding:  4px 10px;
    width: 100%;
    border-radius: 5px;
    border: none;
    margin-top: 10px;
}
.crafting-tool-wrapper {
  padding: 4px 50px;
  height: 180px;
  overflow-y: scroll;
}
.crafting-tool_group {
  margin-top: 5px;
}

.crafting-tool_group span {
  display: inline-block;
  color: #fff;
}
.crafting-tool_group .crafting-img {
  /* width: 80px; */
  margin: auto;
}
.crafting-tool_group .crafting-img img {
  aspect-ratio: 3/3;
  object-fit: contain;
}
</style>
